import { types, Instance } from 'mobx-state-tree'
import { preview } from 'src/constants/typenames'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { View } from 'src/api/misc/View'

// @ts-ignore
export const Preview = types.compose(preview, generateNodeType(preview), View)
